import { Autocomplete, TextField, Button } from "@mui/material";
import { useEffect, useState } from "react";
import Icons from "../../../../resources/icons/Icons";
import { handleTokenOccupied } from "../../../../utils/MenuUtils";
import classes from "../CustomInputs.module.css";

// Tooltip
import * as React from "react";
import CustomTooltip  from "../../Tooltip/CustomTooltip/CustomTooltip";


const TokensListInput = (props) => {
  const [autocompleteValue, setAutocompleteValue] = useState(props.currentAssignedToken ? props.currentAssignedToken : null);

  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [autocompleteValue]);

  useEffect(() => {
    if (props.currentAssignedToken?.id !== autocompleteValue?.id) {
      handleTokenSelect(props.currentAssignedToken);
    }
  }, [props.currentAssignedToken]);

  const handleTokenSelect = (newValue) => {
    setAutocompleteValue(newValue);
    let assignees = "";
    let usersToVerify = [];
    if (
      newValue?.label?.carUserTokens &&
      newValue?.label?.tokenAssignees?.length > 0 &&
      !props.isTokenVerified
    ) {
      newValue?.label?.tokenAssignees?.forEach((assigne) => {
        if (assigne) {
          usersToVerify.push(assigne);
          assignees += ` ${assigne?.firstName} ${assigne?.lastName},`;
        }
      });
      if (assignees) {
        handleTokenOccupied(
          assignees,
          props?.hanedleAssignToExsitUser?.bind(this, usersToVerify),
          resetValue
        );
      }
    } else {
      if (props?.handleSuccess && newValue) {
        props?.handleSuccess();
      }
    }

    props.onChange({ [props.id]: newValue?.label });
  };

  const resetValue = () => {
    props.onChange({ [props.id]: "" });
  };

  const handleDeleteToken = () => {
    setAutocompleteValue(null);
    props.onChange({ [props.id]: "" });
  };

  const getAssigneesLabel = (label) => {
    let assignees = " ";
    if (label?.tokenAssignees && label?.tokenAssignees.length > 0) {
      assignees += "Assigned to: ";
      label?.tokenAssignees?.forEach((assigne) => {
        if (assigne) {
          assignees += ` ${assigne?.firstName} ${assigne?.lastName},`;
        } else {
          assignees += "";
        }
      });
    }

    return assignees;
  };

  return (
    <div className={[classes.customTextField, classes.tokensList].join(' ')}>
      <Autocomplete
        disableClearable={true}
        disablePortal
        value={autocompleteValue}
        defaultValue={props.currentAssignedToken}
        isOptionEqualToValue={(option, value) => option?.value === value?.value}
        onChange={(event, newValue) => {
          handleTokenSelect(newValue);
          // setCurrentAssignedToken(newValue);
          // props.onValueChanged(newValue);
          // props.onChange({ [props.id]: newValue?.label });
        }}
        id="tokensListAutocompleteInput"
        options={props.list}
        className={[classes.textField, classes.tokensAutoComplete].join(' ')}
        getOptionLabel={(option) => {
          let assignees = getAssigneesLabel(option?.label);
          let label = option.label?.displayValue || "";
          return label + assignees;
        }}
        renderOption={(props, option, { selected, inputValue }) => {
          let assignees = getAssigneesLabel(option?.label);
          return (
            <li {...props} key={option.id}>
              <div>
                <span>{option?.label?.displayValue}</span>
                {option?.label?.carUserTokens &&
                  (
                    <span className={classes.isOccupied}>{assignees}</span>
                  )}
              </div>
              <img src={selected ? Icons.CHECKBOX_CIRCLE : ""} />
            </li>
          );
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <img className={classes.searchIcon} src={Icons.SEARCH} />
                ),
                endAdornment: (
                  <span className={[classes.endAdornment, classes.tokenEndAdornment].join(' ')}>
                    {props?.showDeleteButton && (
                      <Button onClick={() => handleDeleteToken()}>
                        <img src={Icons.DELETE_ITEM_4} />
                      </Button>
                    )}
                  </span>
                ),                
              }}
              label={props.label}
              error={props.isStepSubmitted && props.hasError}
              helperText={
                props.isStepSubmitted && props.hasError
                  ? props.errorMessage
                  : ""
              }
            />
          );
        }}
        classes={{
          root: classes.root,
          inputRoot: classes.filed,
          paper: classes.menuPaper,
          option: classes.option,
          listbox: classes.listbox,
          focused: classes.focused,
          input: classes.input,
        }}
      />
      {props.showTooltip && (
          <CustomTooltip {...props} isOutOfField={true}></CustomTooltip>
        )}
    </div>
  );
};

export default TokensListInput;
